import { Root, Thumb } from '@radix-ui/react-switch'
import styled from 'styled-components'

export const SwitchRoot = styled(Root)`
  display: inline-flex;
  width: 28px;
  height: 16px;
  padding: 0;
  flex-shrink: 0;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid transparent;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  transition: all 0.2s;
  outline: none;
  background-color: ${props => props.theme.colors.foreground.base};
  position: relative;
  -webkit-tap-highlight-color: ${props => props.theme.colors.black.base};

  &[data-state='checked'] {
    background-color: ${props => props.theme.colors.primary.base};
  }
  &[data-state='unchecked'] {
    background-color: ${props => props.theme.colors.foreground.light};
  }
  &:focus-visible {
    border-color: ${props => props.theme.colors.background.base};
    box-shadow: 0 0 0 3px ${props => props.theme.colors.background.base};
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const SwitchThumb = styled(Thumb)`
  pointer-events: none;
  display: block;
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
  background-color: ${props => props.theme.colors.background.base};
  transition: transform 0.2s;
  box-sizing: border-box;
  position: relative;
  box-shadow: none;

  &[data-state='checked'] {
    transform: translateX(calc(100% - 2px));
    background-color: ${props => props.theme.colors.white.base};
  }
  &[data-state='unchecked'] {
    transform: translateX(0);
    background-color: ${props => props.theme.colors.background.base};
  }
`
